import React from "react";
import "./blogs.css";
import vastuBanner from "../../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../../components/BlogSlider.js";
import ServiceProduts from "../../components/ServiceProduts.js";

const LoveAstrologyBlog = () => {
  return (
    <div className="services-page">
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       


        <h2>What is Love Astrology?</h2>

      <p>
        Love astrology helps us understand the emotional and romantic
        dimensions of life by interpreting the stars and planetary movements.
        Whether you're single, committed, or in search of your soulmate, your
        birth chart reveals deep truths about your approach to love.
      </p>

      <p>
        Astrologers analyze specific planets, zodiac signs, and houses to
        uncover compatibility, timing, and karmic connections in relationships.
      </p>

      <h2>Key Planets Influencing Love</h2>

      <ul className="astro-benefits">
        <li>
          <strong>Venus (Shukra)</strong> – The planet of romance, attraction,
          sensuality, and emotional harmony.
        </li>
        <li>
          <strong>Moon (Chandra)</strong> – Governs emotions and emotional
          compatibility.
        </li>
        <li>
          <strong>Mars (Mangal)</strong> – Represents passion, desire, and
          physical chemistry.
        </li>
      </ul>

      <h2>Love Houses in Astrology</h2>

      <p>
        Certain houses in your birth chart play major roles in love astrology:
      </p>

      <ul className="astro-benefits">
        <li>
          <strong>5th House</strong> – Represents romance, dating, and emotional
          expression.
        </li>
        <li>
          <strong>7th House</strong> – The house of committed partnerships and
          marriage.
        </li>
        <li>
          <strong>8th House</strong> – Governs intimacy, trust, and deep
          emotional bonds.
        </li>
      </ul>

      <h2>Zodiac Sign Compatibility</h2>

      <p>
        Compatibility in astrology is more than just sun signs. Astrologers look
        at moon signs, Venus, and rising signs for true love matching.
      </p>

      <p>
        Some well-known love combinations:
        <ul className="astro-benefits">
          <li>Aries ❤️ Leo – fiery passion and bold expression</li>
          <li>Taurus ❤️ Cancer – emotional bonding and stability</li>
          <li>Gemini ❤️ Libra – mental connection and charm</li>
          <li>Virgo ❤️ Capricorn – grounded love and loyalty</li>
          <li>Sagittarius ❤️ Aquarius – adventurous and free-spirited union</li>
        </ul>
      </p>

      <h2>Love Timing (Muhurtha)</h2>

      <p>
        Love astrology also helps determine the most auspicious time to propose,
        marry, or start a relationship. Venus transit, full moons, and nakshatras
        play important roles in choosing the right love muhurtha.
      </p>

      <h2>Karmic Love & Twin Flames</h2>

      <p>
        Some charts indicate karmic bonds — where two souls meet again to
        complete emotional lessons from past lives. Such relationships feel
        instantly familiar and emotionally intense.
      </p>

      <p>
        Astrology can indicate twin flames, soulmates, or long-term companions
        based on deep synastry connections.
      </p>

      <h2>Mantras & Remedies for Love</h2>

      <p>
        Struggling in love? Astrologers may recommend remedies like:
        <ul className="astro-benefits">
          <li>Chanting Shukra (Venus) or Moon mantras for emotional healing</li>
          <li>Wearing rose quartz or diamond for attracting love</li>
          <li>Offering sweets or white flowers to Goddess Lakshmi on Fridays</li>
        </ul>
      </p>

      <h2>Sanskrit Wisdom</h2>

      <div className="sanskrit">
        <p>सर्वं प्रेमयि दृष्टिम् - Everything is seen through the lens of love.</p>
        <p>यत्र नार्यस्तु पूज्यन्ते रमन्ते तत्र देवता॥</p>
        <p>– "Where women are honored, divinity blossoms."</p>
      </div>
    
    <p>Apart from the celestial aspects regarding wealth and astrology, in Bhagwad Gita, Chapter 2, Verse 47, Lord Krishna tells Arjuna about the relevance of Karma as follows-</p>
        {/* FAQs */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq"><h4>What is Astro Vastu?</h4><p>Astro Vastu combines Vastu Shastra with astrology to bring personalized solutions based on your birth chart.</p></div>
          <div className="faq"><h4>Can this service be done remotely?</h4><p>Yes, we offer remote consultations through video calls and shared floor plans.</p></div>
          <div className="faq"><h4>How do I choose a gemstone?</h4><p>We analyze your birth chart and planetary positions to recommend suitable gemstones.</p></div>
          <div className="faq"><h4>What is the benefit of Rudraksha?</h4><p>Rudraksha beads help in spiritual growth and balancing chakras and energy fields.</p></div>
        </div>

        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

      </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src={vastuBanner} alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>

        <div className="contact-form">
          <h3>Contact Us</h3>
          <form>
            <input type="text" placeholder="Name" required />
            <input type="email" placeholder="Email" required />
            <input type="tel" placeholder="Phone No" required />
            <select required>
              <option value="">Select Service</option>
              <option value="vastu">Astro Vastu Consultation</option>
              <option value="gemstone">Gemstone Suggestion</option>
              <option value="puja">Puja or Remedy Guidance</option>
            </select>
            <textarea placeholder="Please Write Any Note Here..." required />
            <button type="submit">Submit</button>
          </form>
        </div>

       
          <ServiceProduts />
        
      </div>
    </div>
  );
};

export default LoveAstrologyBlog;
